import { useQuery } from '@tanstack/react-query';
import { serviceKeys, type ServiceListQuery } from '@/services/queryKeys';
import { serviceService } from '@/services/service.service';

/**
 * Trần `page_size` mà BE chấp nhận — `service-filter.dto.ts` khai `@Max(100)`.
 *
 * Vượt trần KHÔNG trả về danh sách dài hơn: BE trả 400. `safeQuery` bên dưới
 * kẹp TRƯỚC khi gửi nên trường hợp 400 này không còn xảy ra qua hook — giữ kẹp
 * ở đây (thay vì sửa từng chỗ gọi) để chỗ gọi thứ ba không lặp lại lỗi.
 */
export const SERVICE_LIST_MAX_PAGE_SIZE = 100;

export function useServiceList(query: ServiceListQuery = {}, options?: { enabled?: boolean }) {
  const safeQuery: ServiceListQuery =
    query.page_size !== undefined
      ? { ...query, page_size: Math.min(query.page_size, SERVICE_LIST_MAX_PAGE_SIZE) }
      : query;

  return useQuery({
    queryKey: serviceKeys.list(safeQuery),
    queryFn: () => serviceService.list(safeQuery),
    enabled: options?.enabled ?? true,
    placeholderData: (prev) => prev,
    // Retry 2 lần như `useGeneralConfig`: một blip mạng không được biến thành
    // "tenant chưa khai dịch vụ nào" (TCR-1104) — trước đây `retry: 0` khiến
    // dropdown Phụ thu/Phí vận chuyển ở POS rỗng vĩnh viễn sau 1 lần lỗi mạng,
    // không có cách nào tự phục hồi ngoài F5.
    retry: 2,
  });
}
